import React from "react";
import Categorys from "./categorys";

const SubNavBar = () => {
  return (
    <div className=" sub-nav container-fluid">
      <div className=" container">
        <Categorys />
      </div>
    </div>
  );
};

export default SubNavBar;
